export default {
  SEARCH_CATALOG_KUSPIT_MARITAL_STATUS_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_MARITAL_STATUS_QUERY'),
  CATALOG_KUSPIT_MARITAL_STATUS_REPOSITORY: Symbol.for('CATALOG_KUSPIT_MARITAL_STATUS_REPOSITORY'),
  CATALOG_KUSPIT_MARITAL_STATUS_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_MARITAL_STATUS_STATE_MANAGER'),
};
